module.exports = __webpack_public_path__ + "img/payrunSheet.790add4f.svg";